import classnames from "classnames";
import { JerseyAvatar } from "../heat/JerseyAvatar";
import { Badge, Box, Typography } from "@mui/material";
import { useRowStyles } from "../commonStyles/tableStyles";

export const AthleteCell = ({
    name,
    alt,
    image,
    team,
    classes,
    hideAvatar,
    avatar,
    onAvatarClick,
    badgeComponent,
}) => {
    const rowClasses = useRowStyles();
    return (
        <td className={classnames(rowClasses.athlete, classes?.athlete)}>
            <Box display="flex" alignItems="center">
                {!hideAvatar && (
                    <div
                        className={classnames(
                            rowClasses.padded,
                            classes?.avatar,
                        )}
                        onClick={onAvatarClick}
                        role="button"
                        aria-label="avatar-area"
                    >
                        {badgeComponent ? (
                            <Badge
                                sx={{ marginRight: 1 }}
                                badgeContent={badgeComponent}
                            >
                                {avatar || (
                                    <JerseyAvatar
                                        src={image}
                                        alt={alt || name}
                                    />
                                )}
                            </Badge>
                        ) : (
                            <>
                                {avatar || (
                                    <JerseyAvatar
                                        src={image}
                                        alt={alt || name}
                                    />
                                )}
                            </>
                        )}
                    </div>
                )}
                <section>
                    <Typography
                        variant="subtitle3"
                        component="p"
                        className={classnames(classes?.name)}
                    >
                        {name}
                    </Typography>
                    {team && (
                        <Typography
                            variant="body2"
                            component="p"
                            color="textSecondary"
                        >
                            {team}
                        </Typography>
                    )}
                </section>
            </Box>
        </td>
    );
};
